<template>
    <div>
        <gSwiper :arr="arr2" :maxH="'inherit'"></gSwiper>
  <div class="register">
   
    <Row :gutter="10" class="top">
      <Col span="12">
      <div class="title">中国国际焙烤展 展商报名</div>
      </Col>
      <Col span="12" class="f-tar">
      <!-- <Button shape="circle" style="border-color:#b10042;color:#b10042;">中文</Button> -->
      <Button shape="circle" style="border-color:#b10042;color:#b10042;" @click="$router.push(`/ex-register-en/register`)">English</Button>
      </Col>
    </Row>
    <registerForm ref="registerForm"></registerForm>
    <registerEntrance ref="registerEntrance"></registerEntrance>

    <div class="f-tac submit-btn">
      <Button type="primary" size="large" @click="handleSubmit" :loading="loading">确认以上信息，并提交展位申请</Button>
    </div>

    <div class="tip-info">
      <p>注：</p>
      <p>1. 展会主办单位有修改、调整展位图的权利。</p>
      <p>2. 此表仅为展位预定时使用，非正式参展合同。正式参展以展位合同为准。</p>
      <p>3.特别提醒：每家展商在签署展位合同的时候，还需同时签署为期1年的B2B线上服务，目前年费优惠价2000元（原价5000元），敬请知悉。</p>
    </div>
  </div>
</div>
</template>
’
<script>
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerEntrance from "./components/register-entrance.vue";
import gSwiper from "@components/gSwiper/gSwiper2.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerEntrance,gSwiper
  },
  props: {},
  data () {
    return {
      loading: false,
      arr2: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202405/8da3d6709bec47559933f9446490f460.jpg' }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerEntrance.validHandle();
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerEntrance', res2);
      let lists = [];
      if (res2.ApplyCompanyOrderNewDto) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto
        });
      }
      if (res2.ApplyCompanyOrderNewDto2) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto2
        });
      }
      let opt = {
        newCompany: { ...res2.common, ...res.form,  },
        lists: lists,
        reportType: 'cn'
      };  
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.name;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if(bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
  },
  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$router.push(`/ex-register/register-mobile`);
    } 
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  .top {
    padding: 29px 0 40px;
  }
  .title {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
}
.submit-btn {
  margin-top: 50px;
  text-align: center;
  button {
    padding: 0 46px;
    height: 48px;
    background-color: #b10042;
    font-size: 16px;
    border-color: #b10042;
    margin-bottom: 80px;
  }
}
.tip-info {
  width: 1200px;
  margin: 0 auto 116px;
  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
  }
}
</style>
